import gsap from 'gsap/all';
import assets from 'app/assets';
import { AnimatedSprite, Rectangle, Texture, Container, TextStyle, Text, DEG_TO_RAD, Sprite, Graphics, Point, BUFFER_BITS, ParticleContainer } from 'pixi.js';
import tools, { isMobileOS } from 'tools';
import Bubble from './bubble';
import Web from './web';
import config from 'config';
import Border from './border';
import Ui from './ui';
import OptionBtn from './optionBtn';
import Btn from './btn';
const VIEW_WIDTH = config.view.x;
const VIEW_HEIGHT = config.view.y;
const BUBBLE_SIZE = 80; //66;
const DECAL = 14; //26;
/** Décalage vertical (px), uniquement mobile portrait — voir onResize / refreshGridY. */
const GRID_NUDGE_UP = 0;
const LINES = 6;
const COLUMNS = 6;
const COEF_DELTA_INC_VALUE = -3.7;
/** Planches oiseaux animés (bsp, gsp, rsp, vsp, ysp, etc.) : 960×960, grille 6×6, frame 160×160. */
const BIRD_SHEET_PX = 960;
const BIRD_SHEET_COLS = 6;
const BIRD_SHEET_ROWS = 6;
const BIRD_FRAME_PX = 160;
const colors = [[1, 1, 0, 0, 2, 2], [3, 4, 4, 4, 1, 1], [4, 1, 0, 0, 2, 2], [4, 4, 3, 1, 3, 1], [4, 1, 4, 0, 3, 2], [2, 1, 0, 4, 4, 4]];
export default class Stage extends Container {
  constructor() {
    super();
    this.actualData = {};
    this.getData();
    tools.autobind(this);
    this.CoefVal = 0;
    this.coefDelta = 1000;
    this.colorPalierScore = assets.gameConfig.palier;
    this.colorIdStep = 0; //colors probability id
    this.steps = assets.gameConfig.steps; //colors probability steps 

    // config.gameOver = true;
    config.touchAccess = false;
    config.bubbles = [];
    config.selectedBubles = [];
    this.b0 = null;
    this.b1 = null;
    this.b2 = null;
    config.Bframes = this.addAnimation(assets.textures.bsp.texture);
    config.Gframes = this.addAnimation(assets.textures.gsp.texture);
    config.Yframes = this.addAnimation(assets.textures.ysp.texture);
    config.Vframes = this.addAnimation(assets.textures.vsp.texture);
    config.Rframes = this.addAnimation(assets.textures.rsp.texture);
    config.Mframes = this.addAnimation(assets.textures.msp.texture);
    this.build();
    this.ui.visible = false;
    config.container.visible = false;
    this.initEvents();
    // this.startLightEffect();
    // single interstitial 
    this.launchInterstitialInterval();

    // Boot directly into gameplay on initial load (same flow as PLAY button).
    this.GoGame();

    // Start the cycle
    this.startRandomLoop();
  }
  /**
   * Découpe une spritesheet 6×6 (36 frames, gauche → droite puis haut → bas).
   * Format standard : 960×960 → frames 160×160. Autres tailles : calcul automatique (ex. msp).
   */
  addAnimation(sourceTexture, cols = BIRD_SHEET_COLS, rows = BIRD_SHEET_ROWS) {
    const baseTex = sourceTexture.baseTexture;
    const w = sourceTexture.width;
    const h = sourceTexture.height;
    const isStandardBirdSheet = w === BIRD_SHEET_PX && h === BIRD_SHEET_PX && cols === BIRD_SHEET_COLS && rows === BIRD_SHEET_ROWS;
    const fw = isStandardBirdSheet ? BIRD_FRAME_PX : Math.floor(w / cols);
    const fh = isStandardBirdSheet ? BIRD_FRAME_PX : Math.floor(h / rows);
    const frames = [];
    for (let i = 0; i < cols * rows; i++) {
      const x = (i % cols) * fw;
      const y = Math.floor(i / cols) * fh;
      frames.push(new Texture(baseTex, new Rectangle(x, y, fw, fh)));
    }
    return frames;
  }
  async startHomePage() {
    // Execution stops here until getData() finishes
    await this.getData();

    //"Data received!"

    this.createHomePage();
  }
  createHomePage() {
    //hide game elements

    this.ui.visible = false;
    config.container.visible = false;
    //create a ontainer for the home page
    this.homeContainer = new Container();
    this.addChild(this.homeContainer);
    this.birds_h = new Sprite(assets.textures.birds_h.texture);
    this.birds_h.anchor.set(0.5, 0.5);
    this.layer = new Sprite(assets.textures.layer.texture);
    this.pop_h = new Sprite(assets.textures.pop_h.texture);
    this.pop_h.anchor.set(0.5, 0.5);
    const PopTitleStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 54,
      fill: '#ffffff',
      //#0b2944
      stroke: '#d9600a',
      strokeThickness: 4,
      align: "center",
      // --- Drop Shadow Settings ---
      dropShadow: true,
      dropShadowColor: '#d9600a',
      // Color of the shadow (usually black)
      dropShadowBlur: 4,
      // Softness of the shadow
      dropShadowAngle: Math.PI / 6,
      // Direction (in radians, e.g., 30 degrees)
      dropShadowDistance: 6,
      // How far the shadow sits from the text
      dropShadowAlpha: 1 // Opacity of the shadow
    });
    this.popText = new Text(assets.local.PersonalRecord, PopTitleStyle);
    this.popText.anchor.set(0.5, 0.5);
    this.logo = new Sprite(assets.textures.logo.texture);
    this.logo.anchor.set(0.5, 0.5);
    const titleStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      fill: '#10b7fe',
      align: "center"
    });
    const ValueStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 20,
      fill: '#0b2944',
      align: "center"
    });
    this.BestScoreText = new Text(assets.local.bestcore.toUpperCase(), titleStyle);
    this.BestScoreText.anchor.set(0.5, 0.5);
    this.BestScoreTextValue = new Text(this.actualData.bestScore, ValueStyle);
    this.BestScoreTextValue.anchor.set(0.5, 0.5);
    this.MaxText = new Text(assets.local.maxLevel.toUpperCase(), titleStyle);
    this.MaxText.anchor.set(0.5, 0.5);
    this.MaxTextValue = new Text("0", ValueStyle);
    if (config.MaxLevel) {
      this.MaxTextValue.text = config.MaxLevel;
    }
    this.MaxTextValue.anchor.set(0.5, 0.5);
    this.FarthestText = new Text(assets.local.farthestWorld.toUpperCase(), titleStyle);
    this.FarthestText.anchor.set(0.5, 0.5);
    this.FarthestTextValue = new Text('0', ValueStyle);
    this.FarthestTextValue.anchor.set(0.5, 0.5);
    const currentLevelData = this.getBG(config.MaxLevel); //config.MaxLevel
    this.FarthestTextValue.text = assets.local[currentLevelData.obj.title];
    const currentLevelData2 = this.getBG(config.playerBubble); //config.MaxLevel
    config.BG.texture = assets.textures[currentLevelData2.obj.bg].texture;
    this.playbt = new Btn("PLAY", 28, "#10b7fe", null, assets.textures.playbt.texture);
    this.playbt.click = this.GoGame.bind(this);
    const platTextStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 60,
      fill: '#ffffff',
      //#0b2944
      align: "center"
    });
    this.playText = new Text(assets.local.play, platTextStyle);
    this.playText.anchor.set(0.5, 0.63);
    this.homeContainer.addChild(this.birds_h);
    this.homeContainer.addChild(this.layer);
    this.homeContainer.addChild(this.pop_h);
    this.homeContainer.addChild(this.popText);
    this.homeContainer.addChild(this.logo);
    this.homeContainer.addChild(this.playbt);
    this.homeContainer.addChild(this.playText);
    this.homeContainer.addChild(this.BestScoreText);
    this.homeContainer.addChild(this.BestScoreTextValue);
    this.homeContainer.addChild(this.MaxText);
    this.homeContainer.addChild(this.MaxTextValue);
    this.homeContainer.addChild(this.FarthestText);
    this.homeContainer.addChild(this.FarthestTextValue);
    this.layer.width = Math.max(window.outerWidth * 1.2, window.outerHeight * 1.2);
    this.layer.height = Math.max(window.outerWidth * 1.2, window.outerHeight * 1.2);

    //reseize home panel
    let spaceH = 1.5;
    if (isMobileOS()) {
      spaceH = 1.5;
      let sc = window.outerWidth * 0.9 / this.birds_h.width;
      if (sc > 0.6) {
        sc = 0.6;
      }
      this.logo.scale.set(sc, sc);
      this.logo.position.set(window.outerWidth * 0.5, this.logo.height * 0.65);
      this.birds_h.scale.set(sc, sc);
      this.birds_h.position.set(window.outerWidth * 0.5, this.logo.y + this.logo.height * 0.65 + this.birds_h.height * 0.5); //

      this.pop_h.scale.set(sc, sc);
      this.pop_h.position.set(this.birds_h.x, this.birds_h.y); //
      this.popText.scale.set(sc, sc);
      this.popText.position.set(this.pop_h.x, this.pop_h.y - this.pop_h.height * 0.4);
      this.playbt.scale.set(sc * 1.4);
      this.playbt.position.set(this.pop_h.x, this.pop_h.y + this.pop_h.height * 0.36);
      this.playText.scale.set(sc * 1.4);
      this.playText.position.set(this.playbt.x, this.playbt.y);
    } else {
      spaceH = 2.7;
      //desktop
      this.birds_h.scale.set(0.7, 0.64);
      this.birds_h.position.set(window.innerWidth * 0.5, window.innerHeight * 0.59);
      this.pop_h.scale.set(0.5, 0.5);
      this.pop_h.position.set(this.birds_h.x, window.innerHeight * 0.62);
      this.popText.scale.set(0.5, 0.5);
      this.popText.position.set(this.pop_h.x, this.pop_h.y - this.pop_h.height * 0.4);
      this.logo.scale.set(0.5, 0.5);
      this.logo.position.set(this.birds_h.x, this.pop_h.y - this.pop_h.height * 0.5 - this.logo.height * 0.5);
      this.playbt.scale.set(0.5 * 1.4);
      this.playbt.position.set(this.pop_h.x, this.pop_h.y + this.pop_h.height * 0.36);
      this.playText.scale.set(0.5 * 1.4);
      this.playText.position.set(this.playbt.x, this.playbt.y);
    }
    this.BestScoreText.position.set(this.pop_h.x, this.pop_h.y - this.pop_h.height * 0.25);
    this.BestScoreTextValue.position.set(this.BestScoreText.x, this.BestScoreText.y + this.BestScoreText.height * 1.1);
    this.MaxText.position.set(this.BestScoreTextValue.x, this.BestScoreTextValue.y + this.BestScoreTextValue.height * spaceH);
    this.MaxTextValue.position.set(this.MaxText.x, this.MaxText.y + this.MaxText.height * 1.1);
    this.FarthestText.position.set(this.MaxTextValue.x, this.MaxTextValue.y + this.MaxTextValue.height * spaceH);
    this.FarthestTextValue.position.set(this.FarthestText.x, this.FarthestText.y + this.FarthestText.height * 1.1);
  }
  ToggleAudio() {
    // Audio is controlled by YouTube Playables. Custom sound buttons are disabled.
    config.youtubePlayables && config.youtubePlayables.syncAudioFromYouTube();
  }
  createPause() {
    config.youtubePlayables && config.youtubePlayables.pausePlaytime();
    if (config.soundOn) {
      config.AllHowlerAudios["ButtonClick"].play();
    }
    //hide game elements
    // this.ui.visible = false;
    //config.container.visible = false;
    //create a ontainer for the home page
    this.pauseContainer = new Container();
    this.addChild(this.pauseContainer);
    this.layerp = new Sprite(assets.textures.layer.texture);
    this.layerp.width = Math.max(window.outerWidth, window.outerHeight * 1.2);
    this.layerp.height = Math.max(window.outerWidth, window.outerHeight * 1.2);
    this.layerp.interactive = true;
    this.pop_p = new Sprite(assets.textures.Pause_Popup.texture);
    this.pop_p.anchor.set(0.5, 0.5);
    this.resumebt = new Btn("", 28, "#ffffff", null, assets.textures.ResumeButton.texture);
    this.resumebt.click = this.GoGame.bind(this);
    const resumeTextStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 48,
      fill: '#ffffff',
      //#0b2944
      align: "center"
    });
    this.resumeText = new Text(assets.local.Resume, resumeTextStyle);
    this.resumeText.anchor.set(0.5, 0.63);
    this.homebt = new Btn("", 28, "#ffffff", null, assets.textures.PinkButton.texture);
    this.homebt.click = this.restartGame.bind(this);
    this.homeText = new Text(assets.local.Home, resumeTextStyle);
    this.homeText.anchor.set(0.5, 0.63);
    this.pauseContainer.addChild(this.layerp);
    this.pauseContainer.addChild(this.pop_p);
    this.pauseContainer.addChild(this.resumebt);
    this.pauseContainer.addChild(this.resumeText);
    this.pauseContainer.addChild(this.homebt);
    this.pauseContainer.addChild(this.homeText);
    if (isMobileOS()) {
      let sc = window.outerWidth * 0.3 / 500;
      if (sc > 0.6) {
        sc = 0.6;
      }
      if (sc < 0.3) {
        sc = 0.3;
      }
      const iosOffsetY = config.platform === 'ios' ? 50 : 0;
      this.pop_p.scale.set(sc, sc);
      this.pop_p.position.set(window.outerWidth * 0.5, window.outerHeight * 0.5 - iosOffsetY);
      this.resumebt.scale.set(sc * 1.4);
      this.resumebt.position.set(this.pop_p.x, this.pop_p.y + this.pop_p.height * 0.1);
      this.resumeText.scale.set(sc * 1.4);
      this.resumeText.position.set(this.resumebt.x, this.resumebt.y);
      this.homebt.scale.set(sc * 1.4);
      this.homebt.position.set(this.pop_p.x, this.pop_p.y + this.pop_p.height * 0.3);
      this.homeText.scale.set(sc * 1.4);
      this.homeText.position.set(this.homebt.x, this.homebt.y);
    } else {
      let sc = 0.5;
      this.pop_p.scale.set(sc, sc);
      this.pop_p.position.set(window.outerWidth * 0.5, window.outerHeight * 0.5);
      this.resumebt.scale.set(sc * 1.4);
      this.resumebt.position.set(this.pop_p.x, this.pop_p.y + this.pop_p.height * 0.1);
      this.resumeText.scale.set(sc * 1.4);
      this.resumeText.position.set(this.resumebt.x, this.resumebt.y);
      this.homebt.scale.set(sc * 1.4);
      this.homebt.position.set(this.pop_p.x, this.pop_p.y + this.pop_p.height * 0.3);
      this.homeText.scale.set(sc * 1.4);
      this.homeText.position.set(this.homebt.x, this.homebt.y);
    }
  }
  restartGame() {
    if (config.soundOn) {
      config.AllHowlerAudios["ButtonClick"].play();
    }
    //hide pause menu
    this.pauseContainer.destroy({
      children: true
    });
    //reset score
    config.ui.score = 0;
    //reset moves
    config.ui.movesText = config.startMoves;
    this.PlayGameOver();
    //open home page
    //this.startHomePage();
  }
  getBG(currentLevel) {
    let bestIndex = 0;
    for (let i = 0; i < config.backgroundLevels.length; i++) {
      // If our current level is higher or equal to the requirement 'L'
      if (currentLevel >= config.backgroundLevels[i].L) {
        bestIndex = i;
      } else {
        // Since the array is sorted, we stop as soon as we hit a level too high
        break;
      }
    }
    return {
      obj: config.backgroundLevels[bestIndex],
      // The full {L, bg} object
      index: bestIndex // The position (0, 1, 2, etc.)
    };
  }
  controlSound(Mute) {
    for (let i = 0; i < config.AllAudios.length; i++) {
      let _a = config.AllAudios[i];
      if (Mute) {
        _a.volume(0);
      } else {
        _a.volume(1);
      }
    }
  }
  GoGame() {
    config.youtubePlayables && config.youtubePlayables.resumePlaytime();
    if (isMobileOS()) {
      // config.GoFullScreen();
      config.handlePageFocus();
    }
    if (config.soundOn && config.AllHowlerAudios?.["playBt_s"]) {
      config.AllHowlerAudios["playBt_s"].play();
    }
    if (config.soundOn && config.AllHowlerAudios?.MusicBackground && !config.AllHowlerAudios.MusicBackground.playing()) {
      config.AllHowlerAudios.MusicBackground.play();
    }

    //remove the home screen
    if (this.homeContainer) this.homeContainer.destroy({
      children: true
    });
    //remove the pause screen
    if (this.pauseContainer) this.pauseContainer.destroy({
      children: true
    });
    //show the game
    this.ui.visible = true;
    config.container.visible = true;
    if (config.MaxLevel > 1 && config.playerLevel == 1 && config.replay) {
      config.replay = false;
      this.BonusReplayTextAnim.visible = true;
      this.BonusReplayTextAnim.scale.set(0);
      this.BonusReplayTextAnim.text = `${assets.local.ExtraCoins}\n+` + config.bonusCoins2;
      this.BonusReplayTextAnim.x = config.header.x + config.header.coinsText.x;
      this.BonusReplayTextAnim.y = config.header.y + config.header.coinsText.y;
      gsap.to(this.BonusReplayTextAnim.scale, {
        delay: 0.5,
        duration: 1,
        x: 1,
        y: 1,
        ease: "back.out(3)"
      });
      gsap.to(this.BonusReplayTextAnim.scale, {
        delay: 2.5,
        duration: 0.5,
        x: 0,
        y: 0,
        ease: "back.out(3)",
        onComplete: () => {
          this.BonusReplayTextAnim.visible = false;
          this.BonusReplayTextAnim.scale.set(1);
          config.level.updateCoins(config.bonusCoins2);
        }
      });
    }
  }
  launchInterstitialInterval() {
    config.youtubePlayables && config.youtubePlayables.startPlaytime();
  }
  clearInterstitialDelay() {
    config.interstitialReady = false;
    this.interstitial && clearTimeout(this.interstitial);
    config.youtubePlayables && config.youtubePlayables.pausePlaytime();
  }
  setColors(val) {
    if (!val) {
      return;
    }
    this.COLORS_ARR = [];
    for (let i = 0; i < val.length; i++) {
      this.COLORS_ARR.push({
        color: tools.hashtagToHexa(val[i].color),
        label: val[i].label,
        texture: val[i].texture
      });
    }
    config.defaultObjectif && config.defaultObjectif.reset();
    this.emit("skinsUpdate");
  }
  initEvents() {
    config.app.on("onUp", this.onUp);
    config.app.on("onDown", this.onDown);
  }
  startLightEffect() {
    this.timeout = setTimeout(() => {
      for (let i = 0; i < config.bubbles.length; i++) {
        for (let j = 0; j < config.bubbles[i].length; j++) {
          config.bubbles[i][j] && config.bubbles[i][j].lightAnim();
        }
      }
    }, 3000);
    this.interval = setInterval(() => {
      for (let i = 0; i < config.bubbles.length; i++) {
        for (let j = 0; j < config.bubbles[i].length; j++) {
          config.bubbles[i][j] && config.bubbles[i][j].lightAnim();
        }
      }
    }, 15000);
  }
  lightEffect() {
    for (let i = 0; i < config.bubbles.length; i++) {
      for (let j = 0; j < config.bubbles[i].length; j++) {
        config.bubbles[i][j] && config.bubbles[i][j].lightAnim();
      }
    }
    this.coefDelta = 0;
    config.hardLevelStep = config.hardLevelStart / 2;
    config.touchAccess = true;
  }
  onUp(event) {
    if (config.gameOver || config.pause) {
      return;
    }
    this.reset();
    if (config.selectedBubles.length < 3) {
      gsap.delayedCall(1, () => {
        !config.isDown && this.startInterstitial();
      });
    }
    if (config.touchAccess) {
      this.destroyselectedBubles();
    }
  }
  onDown(event) {
    if (config.gameOver || config.pause) {
      return;
    }
    this.b0 && this.b0.hint(false);
    this.b1 && this.b1.hint(false);
    this.b2 && this.b2.hint(false);
    this.hand.visible = false;
    this.hand.parent && this.grid.removeChild(this.hand);
  }

  // Missiles

  destroyBubblesFromPoint(x, y, fromBooster = false) {
    config.selectedBubles.push(config.bubbles[x][y]);
    for (let i = 1; i < 6; i++) {
      y - i >= 0 && config.selectedBubles.push(config.bubbles[x][y - i]);
      y + i < 6 && config.selectedBubles.push(config.bubbles[x][y + i]);
      x - i >= 0 && config.selectedBubles.push(config.bubbles[x - i][y]);
      x + i < 6 && config.selectedBubles.push(config.bubbles[x + i][y]);
    }
    let roketDestMax = 500;
    let roketDestMin = -20;
    let time = .55;
    let delay = .8;
    this.fire0Tween.play();
    this.fire1Tween.play();
    this.fire1RotTween.play();
    this.fire.visible = true;
    this.fire.x = x * (BUBBLE_SIZE + DECAL);
    this.fire.y = y * (BUBBLE_SIZE + DECAL);
    if (config.soundOn) {
      config.AllHowlerAudios["bonus_fireworks"].play();
    }
    this.initRocket(x, y, delay, time, this.roketTop, roketDestMin, -roketDestMax, 0, 0);
    this.initRocket(x, y, delay, time, this.roketBottom, roketDestMin, roketDestMax, 180 * DEG_TO_RAD, 1);
    this.initRocket(x, y, delay, time, this.roketLeft, -roketDestMax, roketDestMin, 270 * DEG_TO_RAD, 2);
    this.initRocket(x, y, delay, time, this.roketRight, roketDestMax, roketDestMin, 90 * DEG_TO_RAD, 3);
    this.grid.addChild(this.fire);
    gsap.delayedCall(delay, () => {
      this.fire0Tween.pause();
      this.fire1Tween.pause();
      this.fire1RotTween.pause();
      this.fire.visible = false;
      this.destroyselectedBubles(time, true, fromBooster);
    });
  }
  startInterstitial() {
    config.youtubePlayables && config.youtubePlayables.updatePlaytimeReady();
  }
  initRocket(x, y, delay, time, rocket, destx, desty, rotation, testID) {
    rocket.visible = true;
    rocket.scale.set(1);
    rocket.alpha = 0;
    gsap.to(rocket, {
      duration: delay * .3,
      alpha: 1
    });
    gsap.to(rocket.scale, {
      duration: delay,
      x: .2,
      y: .2,
      ease: "back.out(2)"
    });
    rocket.x = x * (BUBBLE_SIZE + DECAL);
    rocket.y = y * (BUBBLE_SIZE + DECAL);
    rocket.rotation = rotation;
    rocket.tween && rocket.tween.kill();
    rocket.tween = gsap.to(rocket, {
      delay: delay,
      duration: time,
      x: rocket.x + destx,
      y: rocket.y + desty,
      ease: "none",
      onUpdate: () => {
        switch (testID) {
          case 0:
            if (rocket.y <= 0) {
              rocket.visible = false;
            }
            break;
          case 1:
            if (rocket.y >= desty) {
              rocket.visible = false;
            }
            break;
          case 2:
            if (rocket.x <= 0) {
              rocket.visible = false;
            }
            break;
          case 3:
            if (rocket.x >= destx) {
              rocket.visible = false;
            }
            break;
          default:
            break;
        }
      },
      onComplete: () => {
        rocket.visible = false;
      }
    });
    this.grid.addChild(rocket);
  }
  destroyselectedBubles(coefTime = 1, fromMissile = false, fromBooster = false) {
    config.touchAccess = false;
    config.burstSoundId = 0;
    let delay = config.selectedBubles.length > 2 ? config.selectedBubles.length : 0;
    config.web.clear();
    for (var i = 0; i < config.selectedBubles.length; i++) {
      config.selectedBubles[i].dispose(config.selectedBubles.length > 2, i * .075 * coefTime, fromMissile);
    }
    if (config.selectedBubles.length > 0) {
      var lastBubblePosX = config.selectedBubles[config.selectedBubles.length - 1].x + this.grid.x;
      var lastBubblePosY = config.selectedBubles[config.selectedBubles.length - 1].y + this.grid.y;
      var lastBubbleX = config.selectedBubles[config.selectedBubles.length - 1].index.x;
      var lastBubbleY = config.selectedBubles[config.selectedBubles.length - 1].index.y;
    }
    config.selectedBubles = [];
    config.currentNode = null;
    config.currentOverNode = null;
    config.border.progress(0, .1);
    if (delay > 0) {
      config.ui.showMotiontext(delay, lastBubblePosX, lastBubblePosY, fromMissile, fromBooster);
      if (config.hardLevelStep >= config.hardLevelStart) {
        if (this.coefDelta < COEF_DELTA_INC_VALUE + .5) {
          this.coefDelta = COEF_DELTA_INC_VALUE;
        } else {
          this.coefDelta -= .5;
        }
      } else {
        this.CoefVal += Math.random();
        this.coefDelta -= (Math.cos(this.CoefVal) - .2) * 1000;
        this.coefDelta = this.coefDelta >= 0 ? this.coefDelta : 0;
        this.coefDelta /= config.scoreCoef;
      }
      config.currentScore = this._score = this.ui.score + delay + config.scoreMultiplier + this.coefDelta;
      gsap.to(this.ui, {
        duration: .4,
        score: this._score
      });
      config.header && config.header.updateScore(this._score * config.scoreCoef);

      //update colors palier
      if (parseInt(this._score * config.scoreCoef) > this.colorPalierScore) {
        if (this.colorIdStep < this.steps.length - 1) {
          this.colorIdStep++;
          this.colorPalierScore += assets.gameConfig.palier;
        }
      }
      if (delay >= config.bonusScore) {
        this.ui.stars.show();
        this.ui.scoreTextObj.scale.set(1.3);
        gsap.to(this.ui.scoreTextObj.scale, {
          duration: .4,
          x: 1,
          y: 1
        });
      }
      config.scoreMultiplier = 1;
      gsap.delayedCall(delay * (fromMissile ? .1 : 0.08), () => {
        for (let k = 0; k < COLUMNS; k++) {
          this.addNewBubblesProcess(k);
        }
        if (delay >= 9) {
          gsap.delayedCall(3, () => {
            !config.isDown && this.startInterstitial();
          });
        } else {
          gsap.delayedCall(1, () => {
            !config.isDown && this.startInterstitial();
          });
        }
        if (delay >= config.rocketsTriggerLimite && !fromMissile) {
          this.destroyBubblesFromPoint(lastBubbleX, lastBubbleY);
        } else {
          config.touchAccess = true;
        }
        gsap.delayedCall(1, () => {
          config.ui.movesText <= 0 && (config.touchAccess = false);
          this.checkScore();
          if (!config.gameOver) {
            delay < 9 && (config.touchAccess = true);
            config.hintDelayTween && config.hintDelayTween.kill();
            config.hintDelayTween = gsap.delayedCall(config.hintDelay, this.hint);
          } else {
            config.ui.saveScore(this._score);
          }
        });
      });
    } else {
      if (!config.gameOver) {
        config.touchAccess = true;
        config.hintDelayTween && config.hintDelayTween.kill();
        config.hintDelayTween = gsap.delayedCall(config.hintDelay, this.hint);
      }
    }
  }
  addNewBubblesProcess(cID) {
    let c = this.getColumn(cID);
    let tmp;
    let step = this.steps[this.colorIdStep];
    let datas = [];
    for (let i = 0; i < step.length; i++) {
      datas.push({
        id: i,
        coef: step[i]
      });
    }
    for (let j = 0; j < c.length; j++) {
      for (let i = c.length - 1; i > 0; i--) {
        if (c[i] && c[i].destroyed) {
          tmp = c[i];
          c[i] = c[i - 1];
          c[i - 1] = tmp;
        }
      }
    }
    for (let i = 0; i < c.length; i++) {
      if (c[i].destroyed) {
        // let _colorId = parseInt(tools.range(0, 4.99));
        let _colorId = tools.getRandomWithCoef(datas);
        let bulle = new Bubble({
          x: cID,
          y: i
        }, this.COLORS_ARR[_colorId], BUBBLE_SIZE, _colorId);
        bulle.x = c[i].x;
        bulle.y = -50;
        bulle.alpha = 0;
        this.grid.addChild(bulle);
        c[i] = bulle;
      }
    }
    this.updateColumn(cID, c);
    c = this.getColumn(cID);
    let posy = 0;
    for (let i = 0; i < c.length; i++) {
      let e = c[i];
      e.index.x = cID;
      e.index.y = i;
      if (e && e.y != posy) {
        gsap.to(e, {
          delay: .15,
          duration: .4,
          y: posy,
          alpha: 1,
          ease: "back.out(1.5)"
        });
      }
      posy += BUBBLE_SIZE + DECAL;
    }
  }
  getRandomColorData(i, j, debug) {
    let _maxId = this.COLORS_ARR.length - .001; //4.999; 
    let _colorId = parseInt(tools.range(0, _maxId));
    debug && (_colorId = colors[j][i]);
    return this.COLORS_ARR[_colorId];
  }
  getColumn(id) {
    return config.bubbles[id];
  }
  updateColumn(id, arr) {
    config.bubbles[id] = arr;
  }
  startRandomLoop() {
    // Calculate a random delay between 2000ms and 3000ms
    const randomDelay = Math.floor(Math.random() * (3000 - 2000 + 1)) + 2000;
    setTimeout(() => {
      if (!config.gameOver && !config.pause) {
        this.playAbubble();
      }

      // Call this function again to create the next random "heartbeat"
      this.startRandomLoop();
    }, randomDelay);
  }
  playAbubble() { }
  build() {
    //background image : managed in ui.js
    config.BG = this.backgroundImage = new Sprite('');
    let coefB = 768 / 1344;
    this.backgroundImage.width = window.outerWidth * 1.2;
    this.backgroundImage.height = window.outerWidth * coefB * 1.2;
    if (isMobileOS()) {
      this.backgroundImage.height = window.outerHeight * 1.2;
      this.backgroundImage.width = window.outerHeight / coefB * 1.2;
    }
    this.addChild(this.backgroundImage);
    this.backgroundImage.visible = false;
    this.backgroundImage.anchor.set(0.5, 0.5);
    this.backgroundImage.position.set(window.outerWidth * 0.5, window.outerHeight * 0.5);

    //border with color
    config.border = this.border = new Border();
    this.addChild(this.border);

    //game birds container
    config.container = this.container = new Graphics();
    this.container.beginFill(0xff0000, 0);
    this.container.drawRect(0, 0, VIEW_WIDTH, VIEW_HEIGHT);
    this.container.endFill();
    this.addChild(this.container);
    config.containerParticules = this.containerParticules = new Graphics();
    this.containerParticules.beginFill(0xffffff, 0);
    this.containerParticules.drawRect(0, 0, VIEW_WIDTH, VIEW_HEIGHT);
    this.containerParticules.endFill();
    this.addChild(this.containerParticules);
    this.skinBubbles(config.selectedSkin);
    this.fire0 = new Sprite(assets.textures.fire0.texture);
    this.fire1 = new Sprite(assets.textures.fire1.texture);
    this.fire = new Container();
    this.fire.scale.set(1.2);
    this.fire0.anchor.set(.5);
    this.fire0.scale.set(0);
    this.fire0Tween = gsap.to(this.fire0.scale, {
      duration: .15,
      x: 1,
      y: 1,
      repeat: -1
    });
    this.fire.addChild(this.fire0);
    this.fire1.anchor.set(.5);
    this.fire1Tween = gsap.to(this.fire1.scale, {
      delay: .2,
      duration: .15,
      x: .3,
      y: .3,
      repeat: -1
    });
    this.fire1RotTween = gsap.to(this.fire1, {
      duration: .3,
      rotation: Math.PI * 2,
      repeat: -1,
      ease: "none"
    });
    this.fire.addChild(this.fire1);
    this.fire0Tween.pause();
    this.fire1Tween.pause();
    this.fire1RotTween.pause();
    this.fire.visible = false;
    this.roketTop = new Sprite(assets.textures.rocket.texture);
    this.roketTop.scale.set(.2);
    this.roketTop.anchor.x = .5;
    this.roketTop.anchor.y = 1.05;
    this.roketBottom = new Sprite(assets.textures.rocket.texture);
    this.roketBottom.scale.set(.2);
    this.roketBottom.anchor.x = .5;
    this.roketBottom.anchor.y = 1.05;
    this.roketLeft = new Sprite(assets.textures.rocket.texture);
    this.roketLeft.scale.set(.2);
    this.roketLeft.anchor.x = .5;
    this.roketLeft.anchor.y = 1.05;
    this.roketRight = new Sprite(assets.textures.rocket.texture);
    this.roketRight.scale.set(.2);
    this.roketRight.anchor.x = .5;
    this.roketRight.anchor.y = 1.05;
    config.web = this.web = new Web();
    this.container.addChild(this.web);
    // config.web.visible = false;

    this.grid = new Container();
    this.container.addChild(this.grid);
    this.createBubbles();
    this._layer = new Graphics();
    this._layer.beginFill(0x000000, .1);
    this._layer.drawRect(0, 0, VIEW_WIDTH, VIEW_HEIGHT);
    this._layer.endFill();
    this._layer.interactive = true;
    this._layer.visible = false;
    config.particulesContainer = this.particulesContainer = new ParticleContainer(3600, {
      scale: true,
      position: true,
      rotation: true
    });
    this.containerParticules.addChild(config.particulesContainer);
    this.hand = new Sprite(assets.textures.handIcon.texture);
    this.hand.visible = false;
    config.ui = this.ui = new Ui(this._layer);
    this.addChild(this.ui);
    this.addChild(this.containerParticules);
    const coinBonusOnreplay = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: Math.round(window.outerWidth * (50 / 1920)),
      fill: '#ffffff',
      stroke: '#FFD700',
      strokeThickness: Math.round(window.outerWidth * (10 / 1920)),
      align: "center"
    });
    this.BonusReplayTextAnim = new Text("+" + config.scoreMultiplier, coinBonusOnreplay);
    this.BonusReplayTextAnim.anchor.set(.5);
    this.BonusReplayTextAnim.visible = false;
    this.addChild(this.BonusReplayTextAnim);
  }
  initUI() {
    config.ui.init();
    config.ui.pauseBt.click = this.createPause.bind(this);

    // config.ui && (this.parametreBtn.click = config.ui.parametreShow);

    this.onResize(window.innerWidth, window.innerHeight);


  }
  createBubbles(fromSwap) {
    let bulle;
    let colorId = 0;
    let posx = 0;
    let posy = 0;
    let color = this.COLORS_ARR[colorId];
    let i = 0;
    let j = 0;
    let step = this.steps[this.colorIdStep];
    let datas = [];
    for (i = 0; i < step.length; i++) {
      datas.push({
        id: i,
        coef: step[i]
      });
    }
    for (let l = 0; l < LINES; l++) {
      config.bubbles[l] = [];
    }
    if (fromSwap) {
      if (config.soundOn) {
        config.AllHowlerAudios["bonus_swap"].play();
      }
    }
    for (i = 0; i < config.bubbles.length; i++) {
      for (j = 0; j < COLUMNS; j++) {
        // colorId = parseInt(tools.range(0, 4.99));

        colorId = tools.getRandomWithCoef(datas);

        //!\\ for debug
        //colorId = colors[j][i];
        color = this.COLORS_ARR[colorId];
        bulle = new Bubble({
          x: i,
          y: j
        }, color, BUBBLE_SIZE, colorId);
        bulle.x = posx;
        if (fromSwap) {
          bulle.y = posy;
          bulle.scale.set(0);
          gsap.to(bulle.scale, {
            duration: .4,
            x: 1,
            y: 1,
            ease: "back.out(1.5)"
          });
        } else {
          bulle.y = -300;
          gsap.to(bulle, {
            delay: .1,
            duration: .5,
            y: posy,
            ease: "back.out(1.2)"
          });
        }
        posy += BUBBLE_SIZE + DECAL;
        this.grid.addChild(bulle);
        config.bubbles[i][j] = bulle;
      }
      posy = 0;
      posx += BUBBLE_SIZE + DECAL;
    }
    config.hintDelayTween && config.hintDelayTween.kill();
    config.hintDelayTween = gsap.delayedCall(config.hintDelay, this.hint);
    this.hand && this.grid.addChild(this.hand);
  }
  hint() {
    let testBubble;
    let testColor;
    let hintSelection = [];

    //COLORS PARSE
    for (let c = 0; c < this.COLORS_ARR.length; c++) {
      testColor = this.COLORS_ARR[c].label;

      //PARSE BUBBLES
      for (let i = 0; i <= 3; i++) {
        for (let j = 0; j <= 3; j++) {
          //COLLECT 3X3 MATRIX
          hintSelection = [];
          for (let _i = i; _i < i + 3; _i++) {
            for (let _j = j; _j < j + 3; _j++) {
              testBubble = config.bubbles[_i][_j];
              if (testColor == testBubble.label) {
                hintSelection.push(testBubble);
              }
            }
          }

          //CHECK VALIDE CONTINUED LISTE
          for (let k = 0; k < hintSelection.length; k++) {
            //NODE 1
            this.b0 = hintSelection[k];
            for (let _k = k + 1; _k < hintSelection.length; _k++) {
              //NODE 2
              this.b1 = hintSelection[_k];
              if (this.b0 && this.b1 && tools.distance(this.b0, this.b1) < config.lineDistance) {
                for (let __k = _k + 1; __k < hintSelection.length; __k++) {
                  //NODE 3
                  this.b2 = hintSelection[__k];
                  if (tools.distance(this.b2, this.b1) < config.lineDistance) {
                    this.hit0 = this.b0;
                    if (tools.distance(this.b0, this.b1) > tools.distance(this.b0, this.b2)) {
                      this.hit1 = this.b1;
                      this.hit2 = this.b2;
                    } else {
                      this.hit1 = this.b2;
                      this.hit2 = this.b1;
                    }
                    this.b0.hint(true);
                    this.b1.hint(true);
                    this.b2.hint(true);
                    !config.tutoSeen && this.tuto();
                    return;
                  }
                }
              }
            }
          }
        }
      }
    }
    this.hint2();
  }
  hint2() {
    //NO MORE MOVE

    config.ui.showMotiontext(-2);
    this.interstitial && clearInterval(this.interstitial);
    config.gameOver = true;
    config.ui.resultScore = config.currentScore * config.scoreCoef;
    config.noMoreMove = true;
    //config.ui.showPopin();
    config.ui.saveScore(this._score);
    setTimeout(() => {
      //solution : rearrange birds with swap
      config.touchAccess = true;
      config.bubbles[3][2].putTheSwap();
      config.gameOver = false;
      config.noMoreMove = false;
    }, 2000);
  }
  tuto() {
    config.tutoSeen = true;
    this.hand.visible = true;
    this.grid.addChild(this.hand);
    this.hand.x = this.hit0.x;
    this.hand.y = this.hit0.y;
    this.tutoAnim();
  }
  tutoAnim() {
    if (this.hand.visible && this.hit0 && this.hit1 && this.hit2 && this.hit0.parent && this.hit1.parent && this.hit2.parent) {
      gsap.to(this.hand, {
        delay: 0.5,
        duration: 0.25,
        x: this.hit1.x,
        y: this.hit1.y,
        ease: "none"
      });
      gsap.to(this.hand, {
        delay: 0.25,
        duration: 0.25,
        x: this.hit2.x,
        y: this.hit2.y,
        ease: "none"
      });
      gsap.to(this.hand, {
        delay: 1,
        duration: 0,
        x: this.hit0.x,
        y: this.hit0.y,
        onComplete: this.tutoAnim
      });
    }
  }
  async getData() {
    //useful
    //config.sdk.getScoreModule().getBestScore()
    //config.sdk.getScoreModule().setBestScore(score)

    //config.sdk.getProfileModule().getOpponent()
    //config.sdk.getProfileModule().getProfiles(5); : used for leaderboard

    //config.sdk.getStoreModule().get('level')
    //config.sdk.getStoreModule().save("coins", { value: config.coins });

    // Execution pauses here until the fetch is done
    const coins_res = await config.sdk.getStoreModule().get('coins');
    this.actualData.coins = coins_res.coins.value;
    const level_res = await config.sdk.getStoreModule().get('level');
    this.actualData.level = level_res.level.value;
    config.playerLevel = this.actualData.level;
    const Maxlevel_res = await config.sdk.getStoreModule().get('Maxlevel');
    if (Maxlevel_res.Maxlevel) {
      this.actualData.Maxlevel = Maxlevel_res.Maxlevel.value;
      config.MaxLevel = this.actualData.Maxlevel;
    }
    if (config.MaxLevel == undefined) {
      config.MaxLevel = 1;
    }
    const user_res = await config.sdk.getStoreModule().get('user');
    this.actualData.user = user_res.user.value;
    const bestScore_res = await config.sdk.getScoreModule().getBestScore();
    this.actualData.bestScore = bestScore_res;
    config.oldScore = this.actualData.bestScore;

    //config.playerLevel = 5
    // config.MaxLevel =10
  }
  resetData() {
    //config.sdk.getScoreModule().setBestScore(0);
    config.sdk.getStoreModule().save("level", {
      value: 1
    });
  }
  checkScore() {
    if (config.ui.movesText <= 0 && !config.MovesIncProcess) {
      this.resetCountValues();
      this.PlayGameOver();
    }
  }
  PlayGameOver() {
    if (config.goalAchieved) {
      return;
    }
    if (config.soundOn) {
      config.AllHowlerAudios.MusicBackground.stop();
    }
    if (config.soundOn) {
      config.AllHowlerAudios["GameOver"].play();
    }
    config.defaultObjectif._colorRandomStep = 0;
    config.replay = true;
    config.ui.showMotiontext(-1);
    config.gameOver = true;
    config.ui.resultScore = config.currentScore * config.scoreCoef;
    this.currentScore = parseInt(config.currentScore * config.scoreCoef);
    config.sdk.getPlatform().notifyLevelEnd(0, this.currentScore, false);
    config.endSession = true;
    config.playerLevel = 1;

    // Réinit niveau et réactiver les clics sur les bulles (comme closePopin du leaderboard)
    gsap.delayedCall(1, () => {
      config.header.levelText.text = config.playerLevel;
      config.ui.visible = false;
      config.firstTime = true;
      config.ui.bonusMoveVal = 1;
      config.ui.resetMoves(config.startMoves);
      config.ui.score = 0;
      config.level.resetAllBubbles(false);
      config.ui.playerBubble.explod();
      config.header.initPlayers();
    });
    gsap.delayedCall(2, () => {
      config.gameOver = false;
      this.resetData();
      this.createBubbles();
      //this.onResize(window.outerWidth, window.outerHeight, true);
      config.ui.visible = true;
      config.ui.reseize();
      this.startHomePage();
    });
  }
  resetCountValues() {
    config.UpdateCount = false;
    config.UpdateCountData = {
      n: 1,
      data: []
    };
  }
  resetAllBubbles(create) {
    config.hintDelayTween && config.hintDelayTween.kill();
    for (let i = 0; i < config.bubbles.length; i++) {
      for (let j = 0; j < config.bubbles[i].length; j++) {
        config.bubbles[i][j].dispose(true, j * .075, true, false);
      }
    }
    config.bubbles = [];
    config.selectedBubles = [];
    this.coefDelta = 0;
    config.hardLevelStep = 0;
    if (create) {
      gsap.delayedCall(.5, this.createBubbles);
    }
    this.colorPalierScore = assets.gameConfig.palier;
    this.colorIdStep = 0;
    config.touchAccess = true;
    gsap.delayedCall(.5, () => {
      //this.onResize(window.outerWidth, window.outerHeight, true);
    });
  }
  swapBubbles() {
    config.hintDelayTween && config.hintDelayTween.kill();
    for (let i = 0; i < config.bubbles.length; i++) {
      for (let j = 0; j < config.bubbles[i].length; j++) {
        config.bubbles[i][j].disposeForSwap();
      }
    }
    config.bubbles = [];
    config.selectedBubles = [];
    this.coefDelta = 0;
    config.hardLevelStep = 0;
    gsap.delayedCall(.2, () => {
      this.createBubbles(true);
      config.touchAccess = true;
    });
  }
  skinBubbles(themeId) {
    config.themeId = themeId;
    let pack = 0;
    for (let i = 0; i < assets.packs.length; i++) {
      if (assets.packs[i].id == themeId) {
        pack = assets.packs[i];
        break;
      }
    }
    let colorsDatas = pack.datas;
    let background = pack.bgColor;
    this.setColors(colorsDatas);
    config.background.tint = tools.hashtagToHexa(background);
    gsap.delayedCall(.2, () => {
      for (let i = 0; i < config.bubbles.length; i++) {
        for (let j = 0; j < config.bubbles[i].length; j++) {
          for (let k = 0; k < colorsDatas.length; k++) {
            if (config.bubbles[i][j].label == colorsDatas[k].label) {
              config.bubbles[i][j].skin = {
                id: themeId,
                tint: tools.hashtagToHexa(colorsDatas[k].color),
                texture: colorsDatas[k].texture
              };
              break;
            }
          }
        }
      }
    });
  }
  EndlevelAnimation() {
    //config.ui.allGoalsBirds
    let sc = config.ui.allGoalsBirds[0].b.scale.x;
    config.ui.allGoalsBirds.forEach(obj => {
      gsap.to([obj.b.scale, obj.t.scale], {
        duration: .1,
        x: 0.01,
        y: 0.01,
        ease: "bounce.out"
      });
    });
  }
  updateCoins(val) {
    if (Math.abs(val) > 5) {
      config.coins += val;
      if (config.coins < 0) {
        config.coins = 0;
      }
      config.sdk.getStoreModule().save("coins", {
        value: config.coins
      });
      gsap.to(config.header, {
        duration: .4,
        coins: config.coins
      });
    } else {
      config.header.setCoins(val);
    }

    // config.homeMenu && config.homeMenu.checkForSkin();
  }

  
  onResize(w, h, forceY) {

    let paysage = h < w;
    const gridNudgePortraitMobile = isMobileOS() && !paysage ? GRID_NUDGE_UP : 0;
    // let element = document.getElementById("banner-portrait");
    // let bannerHeight = element.getBoundingClientRect().height || 0;
    // let bannerVisibility = window.getComputedStyle(element).getPropertyValue("visibility");

    this.hand.visible = false;
    this.container && tools.fullResize(this.container, w, h, "w");
    this.containerParticules && tools.fullResize(this.containerParticules, w, h, "w");
    this.ui && tools.fullResize(this.ui, w, h, "w");
    this._layer.width = w;
    this._layer.height = h;
    this.container.y = 20;
    this.containerParticules.y = this.container.y;
    config.ui && (this.ui.y = 0);
    this._layer.y = 0;

    /*is._gridMask.y = 165;
     if (!forceY) {
         this._gridMask.scale.x = 750;
     }
     this._gridMask.scale.y = 800;*/

    //this.border.thicknessScale = this.container.scale.y;
    //this.border.resize(w, h);
    
    if (!forceY) {
      this.grid.x = VIEW_WIDTH - (this.grid.width - BUBBLE_SIZE - DECAL) >> 1;
    }
    this.grid.y = (VIEW_HEIGHT - (552 - BUBBLE_SIZE - DECAL) >> 1) + 32 - gridNudgePortraitMobile;
    if (paysage) {
      if (config.boosterMenu) {
        config.boosterMenu.y = VIEW_HEIGHT / 2 + 65;
        config.boosterMenu.x = VIEW_WIDTH / 2;
      }
      this.container && tools.fullResize(this.container, w, h * 1.25, "w");
      this.containerParticules && tools.fullResize(this.containerParticules, w, h * 1.25, "w");
      let coef = h / 720;
      this.container.y = (h > 440 ? -70 : -80) * coef;
      this.containerParticules.y = this.container.y;
      config.boosterMenu && (config.boosterMenu.x = VIEW_WIDTH + 80);
    } else {
      config.boosterMenu && (config.boosterMenu.x = 0);
      config.boosterMenu && (config.boosterMenu.y = 0);
    }
    config.boosterMenu && config.boosterMenu.updateView(paysage);


  }


  refreshGridY() {
    let scree_cof = window.innerHeight / window.innerWidth;
    if (scree_cof > 1.35) {
      const gridNudge = isMobileOS() ? GRID_NUDGE_UP : 0;
      this.grid.y = config.ui.subTitle.y + BUBBLE_SIZE * 1.7 - gridNudge;
    }
  }
  reset() {
    for (let i = 0; i < config.bubbles.length; i++) {
      for (let j = 0; j < config.bubbles[i].length; j++) {
        config.bubbles[i][j] && config.bubbles[i][j].reset && config.bubbles[i][j].reset();
      }
    }
  }
  update(delta) {
    for (let i = 0; i < config.bubbles.length; i++) {
      for (let j = 0; j < config.bubbles[i].length; j++) {
        config.bubbles[i][j] && config.bubbles[i][j].update && config.bubbles[i][j].update();
      }
    }
    if (this.backgroundImage) {
      let coefB = 768 / 1344;
      this.backgroundImage.width = window.outerWidth * 1.2;
      this.backgroundImage.height = window.outerWidth * coefB * 1.2;
      if (this.backgroundImage.height < window.outerHeight * 1.2) {
        this.backgroundImage.height = window.outerHeight * 1.2;
        this.backgroundImage.width = window.outerHeight / coefB * 1.2;
      }
      if (isMobileOS()) {
        this.backgroundImage.height = window.outerHeight * 1.2;
        this.backgroundImage.width = window.outerHeight / coefB * 1.2;
      }
      this.backgroundImage.position.set(window.outerWidth * 0.5, window.outerHeight * 0.5);
    }
    this.ui && this.ui.update();
    if (config.ActiveReseize) {
      this.ui && this.ui.reseize();
      setTimeout(() => {
        this.ui && this.ui.reseize();
        this.refreshGridY();
      }, 500);
      config.ActiveReseize = false;
    }
  }
  get colorsArr() {
    return this.COLORS_ARR;
  }
}
